<template>
  <redmine-table v-if="selectedPlan" :planIdentityId="selectedPlan.Id" :planName="selectedPlan.UniqueIdentifier"/>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import RedmineTable from "../components/Redmine/RedmineTable";
import { planSetter } from "../mixins/planSetter";

export default {
  components: {
    RedmineTable,
  },
  mixins: [planSetter],
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
};
</script>
